<template>
  <v-container loading>
    <v-form ref="companyForm">
      <v-row>
        <v-col>
          <h3>Firma</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="form.company.customer_number"
            label="Kundennummer"
          />
        </v-col>
        <v-col cols="8">
          <v-text-field
            v-model="form.company.name"
            label="Name *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Name muss ausgefüllt sein.']"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.address.street"
            label="Straße *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Straße muss ausgefüllt sein.']"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="form.address.house_number"
            label="Hausnummer *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Hausnummer muss ausgefüllt sein.']"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="form.address.zip"
            label="PLZ *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'PLZ muss ausgefüllt sein.']"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.address.city"
            label="Ort *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Ort muss ausgefüllt sein.']"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h3>Ansprechpartner</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-select
            v-model="form.customer.form_of_address"
            label="Anrede *"
            :items="[
              { value: 'Mr.', text: 'Herr' },
              { value: 'Mrs.', text: 'Frau' },
              { value: 'Mx.', text: 'keine Angabe' },
            ]"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Anrede muss ausgefüllt sein.']"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.customer.first_name"
            label="Vorname *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Vorname muss ausgefüllt sein.']"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.customer.last_name"
            label="Nachname *"
            required
            validate-on-blur
            :rules="[(value) => !!value || 'Nachname muss ausgefüllt sein.']"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.contact.email"
            label="E-Mail *"
            required
            validate-on-blur
            :rules="[
              (value) => !!value || 'E-Mail muss ausgefüllt sein.',
              (value) =>
                /.+@.+\..+/.test(value) ||
                'E-mail muss eine gültige E-Mail-Adresse sein.',
            ]"
          />
        </v-col>
        <v-col>
          <v-text-field v-model="form.contact.phone_number" label="Telefon" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn outline color="primary" dark @click="save">
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'neuer Kunde',
      }
   },
   layout: (h, page) => h(Layout, [page]),

   data () {
      return {
         form: this.$inertia.form({
            number: {
               order: '',
               customer: '',
               seceit1: '',
               seceit2: '',
            },
            company: {
               customer_number: '',
               name: '',
            },
            address: {
               street: '',
               house_number: '',
               zip: '',
               city: '',
            },
            customer: {
               form_of_address: '',
               first_name: '',
               last_name: '',
            },
            contact: {
               email: '',
               phone_number: '',
            },
         }),
      }
   },

   methods: {
      save () {
         this.form.post(this.route('customer.store'))
      },
   },
}
</script>
